
import React, { useState, useEffect } from 'react';
import { auth } from "../../FirebaseConfig"; // Adjust the path if needed
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

import Img from "../assests/Newsletter.png";

const landscapeImages = [
  "/assets/NewsLetter/land1.jpg",
  "/assets/NewsLetter/land2.jpg",
  "/assets/NewsLetter/land3.jpg",
  "/assets/NewsLetter/land4.jpg",
  "/assets/NewsLetter/land5.jpg",
  "/assets/NewsLetter/land6.jpg",
];
const Newsletter = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(currentUser => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  const handleRedirectToLogin = () => {
    window.location.href = "/login";
  };

  return (
    <div className="relative w-full">
      <div className="backdrop-blur-lg bg-opacity-50">
        <div className="max-w-6xl mx-auto p-8">
          <div className="flex flex-col md:flex-row items-center gap-12">
            {/* Left - Image */}
            {!user && ( <div className="w-full md:w-1/2">
              <img
                src={Img}
                className="w-[600px] max-w-lg mx-auto"
                alt="Bee Newsletter"
              />
            </div>  )}

            {/* Right - Text + Action */}
            {!user && (  <div className="w-full md:w-1/2 space-y-8">
              <h2 className="text-xl md:text-2xl font-bold text-gray-900">
                NEWSLETTER SIGN UP
              </h2>
              <p className="text-sm text-black">
                Now we have expanded to several areas across Andhra and Telangana and provide
                cross-pollination services to help farmers improve their production.
                Subscribe for more updates.
              </p>

              {!user && (
                <button
                  onClick={handleRedirectToLogin}
                  className="px-6 py-3 bg-orange-500 text-white font-semibold rounded-md hover:bg-orange-600 transition-colors duration-200"
                >
                  SUBSCRIBE
                </button>
              )}
            </div>
          )}
          </div>

          {/* 🔁 Show image auto-scroll only for logged-in users */}
          {user && (
            <>
             
             <div className="container mx-auto px-4 relative z-10">
        <h1 className="text-xl md:text-4xl font-bold text-gray-800 text-center mb-4">
        NEWSLETTER        </h1>
             
</div>
            <div className="mt-4">
              

              <Swiper
                slidesPerView={"auto"}
                spaceBetween={20}
                autoplay={{
                  delay: 2800,
                  disableOnInteraction: false,
                }}
                loop={false}
                modules={[Autoplay]}
                className="w-full"
              >
                {landscapeImages.map((img, index) => (
                  <SwiperSlide
                    key={index}
                    className="min-w-[300px] md:min-w-[400px] max-w-[500px]"
                  >
                    <img
                      src={img}
                      alt={`landscape-${index}`}
                      className="w-full h-[200px] md:h-[250px] object-cover rounded-lg shadow-md"
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
            </>
          )}
        </div>
      </div>
      
    </div>
  );
};

export default Newsletter;
